import React from 'react';
import { Loader2, Clock } from 'lucide-react';
import TimeSlotPill from './TimeSlotPill';
import { TimeSlotInfo, ServiceInfo } from '../types/reservation.types';

interface TimeSlotGridProps {
  slots: TimeSlotInfo[];
  services: ServiceInfo[];
  selectedTime: string | null;
  loading: boolean;
  error: string | null;
  onSelect: (time: string) => void;
}

const TimeSlotGrid: React.FC<TimeSlotGridProps> = ({
  slots, services, selectedTime, loading, error, onSelect,
}) => {
  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center py-12 gap-3">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
        <span className="text-sm text-muted-foreground">Chargement des créneaux…</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-8 text-destructive text-sm">{error}</div>
    );
  }

  if (slots.length === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground text-sm">
        Aucun créneau disponible pour cette date.
      </div>
    );
  }

  return (
    <div className="space-y-6 py-2">
      {services.map(svc => {
        const svcSlots = slots.filter(s => s.service === (svc.name === 'Déjeuner' ? 'lunch' : 'dinner'));
        if (svcSlots.length === 0) return null;

        return (
          <div key={svc.name}>
            <div className="flex items-center gap-2 mb-3">
              <Clock className="h-4 w-4 text-muted-foreground" />
              <h3 className="text-sm font-semibold text-foreground">{svc.name}</h3>
              <span className="text-xs text-muted-foreground">
                {svc.start} – {svc.end}
              </span>
            </div>
            <div className="flex flex-wrap gap-2">
              {svcSlots.map(slot => (
                <TimeSlotPill
                  key={slot.time}
                  slot={slot}
                  selected={selectedTime === slot.time}
                  onClick={() => onSelect(slot.time)}
                />
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TimeSlotGrid;
